import { ObservableWorkflowNode } from "@/components/Workflows/types";
import { createContext, useContext } from "react";

export const NodeContext = createContext<ObservableWorkflowNode | null>(null);

export const useNode = () => useContext(NodeContext);
